import ChrNewsTab from "../home/ChrNewsTab";
import { NewspaperIcon } from "@heroicons/react/24/solid";
import { PageHeader } from "../../components/ui/PageHeader";

/**
 * /actualites — the press worklist on a page of its own (menu « Actualités »). The dashboard's
 * former tab, the « Signaux presse » folder and the old /restaurant-news all lead here; the
 * dashboard keeps only its « À ne pas manquer » preview.
 */
export default function NewsPage() {
    return (
        <div className="min-h-screen font-sans">
            <div className="mx-auto max-w-screen-2xl px-4 pb-6 md:px-8">
                <PageHeader icon={<NewspaperIcon />} title="Actualités" subtitle="Ouvertures, reprises et recrutements repérés dans la presse" />
                <ChrNewsTab />
            </div>
        </div>
    );
}
